
import { SearchFlightRecommendation, SearchFlightRecommendationFilterItem, SearchFlightRecommendationResponse } from '@/types/models'
import { computed, defineComponent, PropType } from 'vue'

import FlightOption from '@/components/Booking/Flights/FlightOption.vue';
import { LocaleStrings, SearchFlightRecommendationFilterItemType } from '@/types/paramModels';
import { useStore } from 'vuex';

export default defineComponent({
    name: "FlightList",
    emits: ["updateFilteredFlights"],
    components: {
        FlightOption
    },
    props: {
        flightRecommendations: {
            type: Object as PropType<SearchFlightRecommendationResponse>,
            required: true
        },
        selectedFlight: {
            type: Object as PropType<SearchFlightRecommendation>,
            required: true
        },
        pageTexts: {
            type: Object,
            required: true
        },
        localeStrings: {
            type: Object as PropType<LocaleStrings>,
            required: true
        }
    },
    setup(_props, { emit }) {
        const store = useStore();

        const flights = computed(() => _props.flightRecommendations.flights);

        const pageIndex = computed(() => _props.flightRecommendations.paging.pageNumber);

        const cheapestFlight = computed(() => flights.value.find((flight) => {
            return flight.isCheapest;
        }));
        const bestFlight = computed(() => flights.value.find((flight) => {
            return flight.isBest !== flight.isCheapest ?? flight.isBest;
        }));

        const newTag = (tag: SearchFlightRecommendationFilterItem, type: string) => {
            return {
                name: tag.name,
                id: tag.id,
                isSelected: tag.isSelected,
                type: type
            } as SearchFlightRecommendationFilterItemType;
        }

        const selectedTags = computed(() => {
            const tags = Array<SearchFlightRecommendationFilterItemType>();
            const selectedMaxStop = _props.flightRecommendations.searchFilter.maxStops.find(stop => stop.isSelected);
            if (selectedMaxStop) {
                const selectedMaxStopTag = {
                    name: "Maks. " + selectedMaxStop.name + " " + _props.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop'],
                    id: selectedMaxStop.id,
                    isSelected: true,
                    type: "maxStop"
                } as SearchFlightRecommendationFilterItemType;

                tags.push(selectedMaxStopTag);
            }

            if (_props.flightRecommendations.searchFilter.minSliderValue !== _props.flightRecommendations.searchFilter.minSliderValueAvailable) {
                const minTimeTag = {
                    name: _props.pageTexts['hotelListPageSearchFilterLabelTotalTravelPriceMin'] + " " + _props.flightRecommendations.searchFilter.minSliderValue + " " + _props.pageTexts['hotelPageFlightStepFilterPopupLabelHours'],
                    id: "minTime",
                    isSelected: true,
                    type: "minSliderValue"
                } as SearchFlightRecommendationFilterItemType;
                tags.push(minTimeTag);
            }

            if (_props.flightRecommendations.searchFilter.maxSliderValue !== _props.flightRecommendations.searchFilter.maxSliderValueAvailable) {
                const maxTimeTag = {
                    name:  _props.pageTexts['hotelPageFlightStepFilterPopupLabelMax'] + " " + _props.flightRecommendations.searchFilter.maxSliderValue + " " + _props.pageTexts['hotelPageFlightStepFilterPopupLabelHours'],
                    id: "maxTime",
                    isSelected: true,
                    type: "maxSliderValue"
                } as SearchFlightRecommendationFilterItemType;
                tags.push(maxTimeTag);
            }

            for (const travelClass of _props.flightRecommendations.searchFilter.travelClass) {
                if (travelClass.isSelected)
                    tags.push(newTag(travelClass, "travelClass"));
            }

            for (const airline of _props.flightRecommendations.searchFilter.airlines) {
                if (airline.isSelected)
                    tags.push(newTag(airline, "airline"));
            }

            return tags;
        });

        const removeTagFilter = (tag: SearchFlightRecommendationFilterItemType) => {
            store.dispatch('TravelSearchBookingModule/updateFilterFromTags', tag).then(() => {
                emit("updateFilteredFlights");
            });
        }

        return {
            flights,
            pageIndex,
            cheapestFlight,
            bestFlight,
            selectedTags,
            removeTagFilter
        }
    },
})
